<template>
  <transition name="vac-slide-up">
    <div
      v-if="filteredTemplatesText.length"
      class="vac-template-container vac-app-box-shadow"
      :style="{ bottom: `${$parent.$refs.roomFooter.clientHeight}px` }"
    >
      <div class="vac-template-box" style="border-bottom: 1px solid #e1e4e8">
        <v-col cols="11" class="vac-template-header cursor-auto">
          {{ $t('inbox.quickReplies') }}
        </v-col>
        <v-col cols="1" class="vac-template-header-icon" @click="showDialogShownSavedReplies">
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-col>
      </div>
      <div
        v-for="(template, index) in filteredTemplatesText"
        :key="index"
        class="vac-template-box"
        :class="{ 'vac-template-active': index === activeItem }"
        @mouseover="activeItem = index"
        @click="$emit('select-template-text', template)"
      >
        <div class="vac-template-info">
          <div v-if="template.tag" class="vac-template-tag">/{{ template.tag }}</div>
          <div class="vac-template-text">
            {{ template.text }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mdiPencil } from '@mdi/js'

export default {
  name: 'RoomTemplatesText',

  setup() {
    return {
      icons: {
        mdiPencil,
      },
    }
  },

  props: {
    filteredTemplatesText: { type: Array, required: true },
    selectItem: { type: Boolean, default: null },
    activeUpOrDown: { type: Number, default: null },
  },

  emits: ['select-template-text', 'activate-item'],

  data() {
    return {
      activeItem: null,
    }
  },

  watch: {
    filteredTemplatesText(val, oldVal) {
      if (!oldVal.length || val.length !== oldVal.length) {
        this.activeItem = 0
      }
    },
    selectItem(val) {
      if (val) {
        this.$emit('select-template-text', this.filteredTemplatesText[this.activeItem])
      }
    },
    activeUpOrDown() {
      if (this.activeUpOrDown > 0 && this.activeItem < this.filteredTemplatesText.length - 1) {
        this.activeItem++
      } else if (this.activeUpOrDown < 0 && this.activeItem > 0) {
        this.activeItem--
      }
      this.$emit('activate-item')
    },
  },

  methods: {
    showDialogShownSavedReplies() {
      this.$eventBus.$emit('showDialogShownSavedReplies')
    },
  },
}
</script>
